/**
 * Padrão "calculadora financeira":
 *   digitar 1 → 0,01 | digitar 0 → 0,10 | digitar 0 → 1,00
 *
 * Uso no onChange:
 *   onChange={(e) => setValor(moedaInput(e.target.value))}
 *
 * Para inicializar a partir de valor numérico do backend:
 *   value={moedaDisplay(saldo)}
 *
 * Para enviar ao backend (converte de volta para número):
 *   parseMoeda(valor)  →  10.50
 */

/** Formata enquanto o usuário digita (mantém apenas dígitos, desloca centavos). */
export function moedaInput(rawValue) {
    const digits = String(rawValue).replace(/\D/g, '');
    if (!digits) return '0,00';
    const cents = parseInt(digits, 10);
    return (cents / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/** Formata um valor numérico vindo da API para exibição (ex: 10.5 → "10,50"). */
export function moedaDisplay(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/** Converte o valor formatado de volta para número antes de enviar ao backend. */
export function parseMoeda(value) {
    if (!value && value !== 0) return 0;
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.')) || 0;
}
